export default [
    {
        path: 'solicitacao',
        component: () => import(
            /* webpackChunkName: 'manutencao-solicitacao' */
            '@/views/manutencao/solicitacao/Index'
        ),
        redirect: 'solicitacao/index',
        children: [
            {
                name: 'manutencao-solicitacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'manutencao-solicitacao' */
                    '@/views/manutencao/solicitacao/List.vue'
                ),
            },
            {
                name: 'manutencao-solicitacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'manutencao-solicitacao' */
                    '@/views/manutencao/solicitacao/Form.vue'
                ),
            },
            {
                name: 'manutencao-solicitacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'manutencao-solicitacao' */
                    '@/views/manutencao/solicitacao/Form.vue'
                ),
            },
        ],
    },
]